import React, {useMemo} from 'react';
import Iframe from 'react-iframe';

import {useClientSession} from 'hooks';
import {AsyncRequestTypeName, SumaDocumentVerificationSDKData} from 'interfaces';

export const ClientAsyncRequest: React.FC = () => {
    const {asyncRequestToHandle, audioVideoAsColumn} = useClientSession();

    const sumaDocumentVerificationSDKData = useMemo(() =>
        asyncRequestToHandle?.type === AsyncRequestTypeName.SumaDocumentVerificationSDK ?
     asyncRequestToHandle?.data as SumaDocumentVerificationSDKData : null,
    [asyncRequestToHandle]);

    if (!asyncRequestToHandle) {
        return null;
    }

    if (sumaDocumentVerificationSDKData) {
        return (
            <Iframe
                className='suma-document-verification-sdk-iframe'
                url={sumaDocumentVerificationSDKData?.url}
                allow='autoplay *;camera *;microphone *;'
                height='100%'
                styles={{maxWidth: 800, margin: '0 auto'}}
                width={audioVideoAsColumn ? '75%' : '100%'}
            />);
    }

    return null;
};